export default __webpack_public_path__ + "static/media/college_of_clean.918de616.svg";